import moment from "moment";

export const getDeploymentStage = (tenantUrl) => {
  const msDomain = tenantUrl?.split(".")?.[1];
  switch (msDomain) {
    case "tsl-terls":
      return "dev";
    case "tsl-barc":
      return "qa";
    default:
      return "stage";
  }
};

export const complileResults = (results) => {
  return Object.keys(results || {}).reduce((acc, curr) => {
    acc.passed = (acc?.passed || 0) + (results[curr]?.passed || 0);
    acc.failed = (acc?.failed || 0) + results[curr]?.failed || 0;
    acc.skipped = (acc?.skipped || 0) + results[curr]?.skipped || 0;
    return acc;
  }, {});
};

const getWfSuffix = (run) => {
  const arr = run?.argoWfID?.split("-");
  return arr[arr.length - 1];
};

const getDuration = (run) => {
  const start = moment(run?.startTime);
  const end = moment(run?.endTime);
  if (!run?.startTime || !run?.endTime || !start.isValid() || !end.isValid()) {
    return "—";
  }
  const duration = moment.duration(end.diff(start));
  if (duration.asSeconds() < 0) return "—";
  const hours = Math.floor(duration.asHours());
  const minutes = duration.minutes();
  return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
};

// startTime/endTime stay raw instants; the table renders them via TimeCell.
export const adaptAutomationRuns = (runs) => {
  return runs.map((run) => ({
    ...run,
    workflowSuffix: getWfSuffix(run),
    compliedResults: complileResults(run?.resultMetadata?.results),
    duration: getDuration(run),
  }));
};
